module.exports = __webpack_public_path__ + "e54f08c54faf7123a3f2a450e104debf.png";